import React, { useMemo } from "react";
import ChatItemAction from "./ChatItemAction";
import { Dropdown, Menu } from "antd";
import { conversationActionPermissionMatrix } from "./permissionMatrix";
import { t } from "i18next";
import ChatItemActionsMobile from "./ChatItemActionsMobile";
import { useIsMobileView } from "frontend-lib/Utils/Mobile";

function ChatItemActions({ chat, assignStatus, ownerStatus, adminStatus, actionCb }) {
    const [INM] = useIsMobileView();

    const showActions = Object.entries(conversationActionPermissionMatrix).some((action) => {
        return action[1][assignStatus][ownerStatus][adminStatus];
    });

    const buttonData = () => {
        return Object.entries(conversationActionPermissionMatrix)
            .map((action) => {
                if (chat.startedWaitingOn && action[0] === "markUnread") {
                    return undefined;
                }
                if (!chat.startedWaitingOn && action[0] === "markRead") {
                    return undefined;
                }
                return {
                    key: action[0],
                    action: action[0],
                    permissions: action[1],
                };
            })
            .filter((data) => data !== undefined);
    };

    const renderButtonsWeb = () => {
        return buttonData().map((data) => {
            return (
                <ChatItemAction
                    key={data.key}
                    action={data.action}
                    permissions={data.permissions}
                    text={t("chatOptions." + data.action)}
                    actionCb={actionCb}
                    assignStatus={assignStatus}
                    ownerStatus={ownerStatus}
                    adminStatus={adminStatus}
                />
            );
        });
    };

    if (showActions) {
        return (
            <>
                {INM ? (
                    <ChatItemActionsMobile
                        buttonsProps={buttonData()}
                        assignStatus={assignStatus}
                        ownerStatus={ownerStatus}
                        adminStatus={adminStatus}
                        actionCb={actionCb}
                    />
                ) : (
                    <div onClick={(e) => e.stopPropagation()}>
                        <Dropdown.Button
                            trigger="click"
                            key={"HeaderMenu"}
                            overlay={<Menu>{renderButtonsWeb()}</Menu>}
                        />
                    </div>
                )}
            </>
        );
    }
    return null;
}
export default ChatItemActions;
